import { trans } from "@mongez/localization";
import breadcrumbImage from "app/assets/images/about-us/breadcrumb.jpg";
import { pageHead } from "framework/config/meta";
import { URLS } from "framework/config/urls";
import { Breadcrumbs } from "~/design-system/components/breadcrumbs";
import { ContactUsPage } from "~/modules/contact-us/pages";

export function meta() {
  return pageHead({
    title: trans("contactUs"),
  });
}

export default function ContactUs() {
  return (
    <>
      <Breadcrumbs
        image={breadcrumbImage}
        title="contactUs"
        items={[
          { text: trans("home"), href: URLS.home },
          { text: "contactUs" },
        ]}
      />
      <ContactUsPage />
    </>
  );
}
